function Accordion(params) {
    if(!params) {
        return;
    }
    
    this.setupDefaults(params);
    this.addListeners();
};

Accordion.prototype.setupDefaults = function (params) {
    this.activeClass = params.activeClass || 'active';
    this.animationLength = params.animationLength || 400;
    
    this.dom = {
        $container: params.container,
        $trigger: params.container.find(params.trigger),
        $content: params.container.find(params.content)
    };
};

Accordion.prototype.addListeners = function () {
    this.dom.$trigger.on('click touchstart', this.animate.bind(this));
};

Accordion.prototype.animate = function (e) {
    e.stopPropagation();
    e.preventDefault();
    
    if(this.dom.$container.hasClass(this.activeClass)) {
        this.dom.$container.removeClass(this.activeClass);
        this.dom.$trigger.find('span').attr('class', 'fa fa-plus');
        this.dom.$content.slideUp(350);
    } else {
        this.dom.$container.addClass(this.activeClass);
        this.dom.$trigger.find('span').attr('class', 'fa fa-minus');
        this.dom.$content.slideDown(350);
    }
};

$('.wp-FAQ__item').each(function(i, el) {
    new Accordion({
        activeClass: 'active',
        animationLength: 400,
        container: $(el),
        trigger: '.wp-FAQ__item-title',
        content: '.wp-FAQ__item-content'
    });
});